import { makeStyles } from "tss-react/mui";
import { Step, StepLabel, Stepper } from "@mui/material";

export function MiStepper({
  activeStep,
  steps,
  setActiveStep,
  disabled,
}: MiStepperProps) {
  const { classes } = useStyles();

  const handleStep = (step: number) => () => {
    if (!disabled) {
      setActiveStep(step);
    }
  };

  return (
    <Stepper
      activeStep={activeStep}
      className={classes.stepperContainer}
      alternativeLabel
    >
      {steps.map((step) => (
        <Step key={step.label}>
          <StepLabel
            className={classes.stepLabel}
            onClick={handleStep(step.value)}
          >
            {step.label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

const useStyles = makeStyles()((theme) => ({
  stepperContainer: {
    backgroundColor: theme.palette.common.white,
    padding: 4,
    width: "100%",
  },
  stepLabel: {
    cursor: "pointer",
    "& .MuiStepLabel-alternativeLabel": {
      marginTop: 0,
    },
  },
}));

interface Steps {
  value: number;
  label: string;
}

interface MiStepperProps {
  activeStep: number;
  setActiveStep: (step: number) => void;
  disabled?: boolean;
  steps: Steps[];
}
